module.exports = __webpack_public_path__ + "static/media/february-2022.8844ee5d.svg";